import { Card, Grid } from '@mui/material';
import React, { Fragment } from 'react';
import { VendorDTO } from 'wisestep-api';
import { Item, WsTypoColors, WsTypography } from 'wisestep-base';

import { getVendorInfoDetailsArray } from '../helper/VendorDetailHelper';

interface VendorBasicInfoProps {
  vendor: VendorDTO;
}

const VendorBasicInfo: React.FC<VendorBasicInfoProps> = ({ vendor }) => {
  const detailsArray = getVendorInfoDetailsArray(vendor);

  return (
    <Grid item container xs={12} spacing={1} pl={1} mt={3}>
      <Card sx={{ width: '100%' }}>
        <Grid item container xs={12} p={1}>
          <Grid item xs={1.5}>
            <Item>
              <WsTypography color={WsTypoColors.SECONDARY}>Address</WsTypography>
            </Item>
          </Grid>
          <Grid item xs={10.5}>
            <Item>
              <WsTypography>{vendor?.address}</WsTypography>
            </Item>
          </Grid>
          {detailsArray?.map((item, index) => (
            <Fragment key={index}>
              <Grid item xs={1.5}>
                <Item>
                  <WsTypography color={WsTypoColors.SECONDARY}>{item.label}</WsTypography>
                </Item>
              </Grid>
              <Grid item xs={2.5}>
                <Item>
                  <WsTypography>{item?.value ?? 'Not Available'}</WsTypography>
                </Item>
              </Grid>
            </Fragment>
          ))}
        </Grid>
      </Card>
    </Grid>
  );
};

export default VendorBasicInfo;
